import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import "./HeaderBar.css";

const navItems = [
  { to: "/", label: "Home" },
  { to: "/projects", label: "Projects" },
  { to: "/blog", label: "Writing" },
  { href: "/#about", label: "About" },
];

function HeaderBar({ data = {} }) {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const email = data.email || "do.huan.saito@gmail.com";
  const isHome = location.pathname === "/";

  return (
    <nav className={`site-nav${open ? " site-nav--open" : ""}${isHome ? "" : " site-nav--inner-page"}`} aria-label="Primary navigation">
      <div className="site-nav__inner">
        <Link className="site-nav__brand" to="/" onClick={() => setOpen(false)}>
          Jay Do<span>.</span>
        </Link>

        <button
          className="site-nav__toggle"
          type="button"
          aria-label={open ? "Close navigation" : "Open navigation"}
          aria-expanded={open}
          onClick={() => setOpen((value) => !value)}
        >
          {open ? <CloseRoundedIcon /> : <MenuRoundedIcon />}
        </button>

        <div className="site-nav__links">
          {navItems.map((item) => (
            item.href ? (
              <a key={item.label} href={item.href} onClick={() => setOpen(false)}>
                {item.label}
              </a>
            ) : (
              <Link key={item.label} to={item.to} onClick={() => setOpen(false)}>
                {item.label}
              </Link>
            )
          ))}
          <a className="site-nav__cta" href={`mailto:${email}`} onClick={() => setOpen(false)}>
            Work with me
          </a>
        </div>
      </div>
    </nav>
  );
}

export default HeaderBar;
